import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import cn from 'classnames';

import styles from './styles.scss';

export default class Menu extends React.PureComponent {
  static propTypes = {
    tenderId: PropTypes.number.isRequired,
    tab: PropTypes.string.isRequired,
    access: PropTypes.objectOf(PropTypes.any).isRequired,
  };
  render() {
    const { tab, tenderId, access } = this.props;
    return (
      <div className={styles.menu}>
        {(access.eventsView || access.commentView) && (
          <Link
            to={`/tender/${tenderId}/history`}
            className={tab === 'history' ? cn(styles.tab, styles.selected) : styles.tab}
          >
            История изменений
          </Link>
        )}
        {access.documentsView && (
          <Link
            to={`/tender/${tenderId}/documents`}
            className={tab === 'documents' ? cn(styles.tab, styles.selected) : styles.tab}
          >
            Документы
          </Link>
        )}
        {access.attributeView && (
          <Link
            to={`/tender/${tenderId}/attributes`}
            className={tab === 'attributes' ? cn(styles.tab, styles.selected) : styles.tab}
          >
            Параметры тендера
          </Link>
        )}
        {access.participantsView && (
          <Link
            to={`/tender/${tenderId}/participants`}
            className={tab === 'participants' ? cn(styles.tab, styles.selected) : styles.tab}
          >
            Участники тендера
          </Link>
        )}
      </div>
    );
  }
}
